import { useRef, useState, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";

import { 
  DEFAULT_GOAL_STYLE_VALUE,
  GOAL_STYLE_OPTIONS,
  DEFAULT_GOAL_LIMIT,
} from "components/Admin/SettingsBlock/SettingsBlock.constants";

import Modal from "components/Admin/Modal";

export default function GoalModal({ isOpen, values, close, submit, updateCurrent }) {
  const [ isErrorsEnabled, setIsErrorsEnabled ] = useState(false);
  const nameFieldRef = useRef();
  const maxLimitFieldRef = useRef();
  const currentFieldRef = useRef();
  const styleFieldRef = useRef();

  const isEdit = !!values;
  const initialName = values?.name || "";
  const initialMaxLimit = isEdit ? parseInt(values?.max_limit || 0) : DEFAULT_GOAL_LIMIT;
  const initialCurrent = isEdit ? parseInt(values?.current || 0) : 0;
  const initialStyle = values?.style || DEFAULT_GOAL_STYLE_VALUE;
  const modalTitle = `${isEdit ? "Edit" : "Create"} donation goal`;
  const saveButtonText = isEdit ? "Save" : "Create";
  
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        nameFieldRef?.current?.focus();
      }, 200)
    }
  }, [isOpen])
  
  const onClose = () => {
    setIsErrorsEnabled(false);
    close();
  };

  const onSave = async () => {
    const form = {
      max_limit: parseInt(maxLimitFieldRef?.current?.value || DEFAULT_GOAL_LIMIT),
      name: nameFieldRef?.current?.value,
      style: styleFieldRef?.current?.value,
    };

    if (Object.values(form).some(val => !val && val !== 0)) {
      setIsErrorsEnabled(true);
    } else {
      const result = await submit(form, values?.id || null);

      if (result) {
        if (`${currentFieldRef?.current?.value}` !== `${initialCurrent}`) {
          updateCurrent(result.id, currentFieldRef?.current?.value || 0);
        }
        
        onClose();
      }
    }
  };
  
  return (
    <div className="goalModal">
      <Modal open={isOpen} onClose={onClose}>
        <DialogTitle>{modalTitle}</DialogTitle>
        <DialogContent>
          <TextField
            inputRef={nameFieldRef}
            error={isErrorsEnabled && !nameFieldRef?.current?.value}
            autoFocus
            margin="dense"
            id="name"
            label="Name"
            defaultValue={initialName}
            type="text"
            fullWidth
            variant="standard"
          />
          <TextField
            inputRef={maxLimitFieldRef}
            error={isErrorsEnabled && !maxLimitFieldRef?.current?.value}
            margin="dense"
            id="max_limit"
            label="Max limit"
            defaultValue={initialMaxLimit}
            type="text"
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            fullWidth
            variant="standard"
          />
          <TextField
            inputRef={currentFieldRef}
            error={isErrorsEnabled && !currentFieldRef?.current?.value}
            margin="dense"
            id="current"
            label="Current"
            defaultValue={initialCurrent}
            type="text"
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            fullWidth
            variant="standard"
          />
          <TextField
            inputRef={styleFieldRef}
            error={isErrorsEnabled && !styleFieldRef?.current?.value}
            id="style"
            select
            label="Style"
            defaultValue={initialStyle}
            margin="dense"
            fullWidth
            variant="standard"
          >
            {GOAL_STYLE_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={onSave}>{saveButtonText}</Button>
        </DialogActions>
      </Modal>
    </div>
  );
}